"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[7580],{

/***/ 695
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/.pnpm/@hotwired+stimulus@3.2.2/node_modules/@hotwired/stimulus/dist/stimulus.js
var stimulus = __webpack_require__(7809);
// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@14.2.0/node_modules/swiper/swiper.mjs + 1 modules
var swiper = __webpack_require__(481);
// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@14.2.0/node_modules/swiper/modules/navigation.mjs
var navigation = __webpack_require__(398);
// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@14.2.0/node_modules/swiper/modules/pagination.mjs
var pagination = __webpack_require__(120);
// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@14.2.0/node_modules/swiper/shared/utils.mjs
var utils = __webpack_require__(943);
;// ./node_modules/.pnpm/swiper@14.2.0/node_modules/swiper/modules/manipulation.mjs


function addSlide(index, slides) {
    const swiper = this;
    const { params, activeIndex, slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for (let i = baseLength - 1; i >= index; i -= 1) {
        const currentSlide = swiper.slides[i];
        if (!currentSlide)
            continue;
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (Array.isArray(slides)) {
        for (let i = 0; i < slides.length; i += 1) {
            const slide = slides[i];
            if (slide)
                slidesEl.append(slide);
        }
        newActiveIndex =
            activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    }
    else {
        slidesEl.append(slides);
    }
    for (let i = 0; i < slidesBuffer.length; i += 1) {
        slidesEl.append(slidesBuffer[i]);
    }
    swiper.recalcSlides();
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!params.observer || swiper.isElement) {
        swiper.update();
    }
    if (params.loop) {
        swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    }
    else {
        swiper.slideTo(newActiveIndex, 0, false);
    }
}

function appendSlide(slides) {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (params.loop) {
        swiper.loopDestroy();
    }
    const appendElement = (slideEl) => {
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0,utils.w)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child)
                slidesEl.append(child);
            (0,utils.w)(tempDOM, '');
        }
        else {
            slidesEl.append(slideEl);
        }
    };
    if (Array.isArray(slides)) {
        for (let i = 0; i < slides.length; i += 1) {
            const slide = slides[i];
            if (slide)
                appendElement(slide);
        }
    }
    else {
        appendElement(slides);
    }
    swiper.recalcSlides();
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!params.observer || swiper.isElement) {
        swiper.update();
    }
}

function prependSlide(slides) {
    const swiper = this;
    const { params, activeIndex, slidesEl } = swiper;
    if (params.loop) {
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl) => {
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0,utils.w)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child)
                slidesEl.prepend(child);
            (0,utils.w)(tempDOM, '');
        }
        else {
            slidesEl.prepend(slideEl);
        }
    };
    if (Array.isArray(slides)) {
        for (let i = 0; i < slides.length; i += 1) {
            const slide = slides[i];
            if (slide)
                prependElement(slide);
        }
        newActiveIndex = activeIndex + slides.length;
    }
    else {
        prependElement(slides);
    }
    swiper.recalcSlides();
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!params.observer || swiper.isElement) {
        swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
}

function removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for (let i = 0; i < swiper.slides.length; i += 1) {
        slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
}

function removeSlide(slidesIndexes) {
    const swiper = this;
    const { params, activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    if (Array.isArray(slidesIndexes)) {
        for (let i = 0; i < slidesIndexes.length; i += 1) {
            const indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove])
                swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex)
                newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    else {
        const indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove])
            swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex)
            newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!params.observer || swiper.isElement) {
        swiper.update();
    }
    if (params.loop) {
        swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    }
    else {
        swiper.slideTo(newActiveIndex, 0, false);
    }
}

const Manipulation = ({ swiper }) => {
    Object.assign(swiper, {
        appendSlide: appendSlide.bind(swiper),
        prependSlide: prependSlide.bind(swiper),
        addSlide: addSlide.bind(swiper),
        removeSlide: removeSlide.bind(swiper),
        removeAllSlides: removeAllSlides.bind(swiper),
    });
};



;// ./_components/blocks/_product_card/images/index.js




class ProductCardImagesController extends stimulus.Controller {
  static targets = [
    'container',
    'nextButton',
    'prevButton',
    'pagination',
    'thumbnailStrip'
  ]
  static values = { selectedProduct: Object, disableCarousel: Boolean, defaultImage: Object, showThumbnails: Boolean }

  MAX_THUMBNAILS = 5

  // Generate srcset from a Shopify CDN image URL
  generateSrcset(src) {
    if (!src) return ''
    const widths = [400, 600, 800]
    return widths.map(w => {
      // Handle URLs that already have width parameter
      const url = new URL(src, window.location.origin)
      url.searchParams.set('width', w)
      return `${url.toString()} ${w}w`
    }).join(', ')
  }

  loadSwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }

    this.swiper = new swiper["default"](this.containerTarget, {
      modules: [navigation["default"], pagination["default"], Manipulation],
      slidesPerView: this.disableCarouselValue ? 1 : 1.15,
      spaceBetween: 20,
      navigation: {
        nextEl: this.nextButtonTarget,
        prevEl: this.prevButtonTarget,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: this.disableCarouselValue ? false : true,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 1000
        }
      },
      allowSlideNext: !this.disableCarouselValue,
      allowSlidePrev: !this.disableCarouselValue,
    })

    this.swiper.slideToLoop(1, 0)
  }

  renderThumbnails(thumbnailItems) {
    this.thumbnailStripTarget.innerHTML = ''

    const thumbsToShow = thumbnailItems.slice(0, this.MAX_THUMBNAILS)

    if (thumbsToShow.length <= 1 || this.disableCarouselValue || !this.showThumbnailsValue) {
      return
    }

    thumbsToShow.forEach(({ src, alt, slideIndex }) => {
      const thumb = document.createElement('button')
      thumb.type = 'button'
      thumb.className = 'w-[calc(25%-0.1875rem)] flex-shrink-0 aspect-[4/3] rounded overflow-hidden border-2 border-transparent hover:border-gray-400 transition-colors focus-visible:ring-2 focus-visible:ring-gray-400'
      const img = document.createElement('img')
      img.src = src
      img.alt = alt
      img.className = 'w-full h-full object-cover'
      thumb.appendChild(img)
      thumb.addEventListener('click', () => {
        this.swiper.slideToLoop(slideIndex, 300)
      })
      this.thumbnailStripTarget.appendChild(thumb)
    })
  }

  selectedProductValueChanged() {
    if (!this.swiper) {
      this.loadSwiper()
    }

    this.swiper.removeAllSlides()

    const mediaItems = this.selectedProductValue.mediaItems || []
    const hasVariantImage = this.selectedProductValue.variant?.image && !(this.selectedProductValue.variant.image.exists == "false")
    const thumbnailItems = []

    mediaItems.forEach((media, index) => {
      if (this.hideCarouselValue && index > 0) {
        return
      }

      if (!(typeof this.defaultImageValue.src === 'undefined') && index === 0) {
        media = this.defaultImageValue
      } else if (!(typeof this.selectedProductValue.defaultImage === 'undefined') && index === 0) {
        media.mediaType = 'image'
        media.src = this.selectedProductValue.defaultImage
      } else if (hasVariantImage && index === 0) {
        media.mediaType = 'image'
        media.src = this.selectedProductValue.variant.image.src
        media.alt = this.selectedProductValue.variant.image.alt
      }

      if (media.mediaType === 'image') {
        thumbnailItems.push({ src: media.src, alt: media.alt, slideIndex: index })
      }

      let slide = document.createElement('div')
      slide.classList.add('swiper-slide', 'my-auto', 'max-w-[880px]', 'max-h-[600px]')

      if (media.mediaType === 'image') {
        const srcset = this.generateSrcset(media.src)
        slide.innerHTML = `<img src="${media.src}" srcset="${srcset}" sizes="(min-width: 1280px) 800px, (min-width: 1024px) 600px, (min-width: 768px) 500px, 100vw" alt="${media.alt}" class="object-cover w-full max-w-[880px] max-h-[600px] h-auto rounded-lg" />`
      } else if (media.mediaType === 'video') {
        slide.innerHTML = `
          <video controls class="w-full h-auto rounded-lg">
            <source src="${media.sources[1]?.url}" type="${media.sources[1]?.mimeType}">
            Your browser does not support the video tag.
          </video>`
      }

      this.swiper.appendSlide(slide)
    })

    // Enable loop only if there are more than one slide
    this.nextButtonTarget.classList.toggle('md:flex', (mediaItems.length > 1 && !this.disableCarouselValue))
    this.prevButtonTarget.classList.toggle('md:flex', (mediaItems.length > 1 && !this.disableCarouselValue))
    this.paginationTarget.classList.toggle('hidden', this.disableCarouselValue)

    if (window.matchMedia('(max-width: 768px)').matches) {
      if (mediaItems.length > 1 && !this.disableCarouselValue) {
        this.swiper.params.slidesPerView = 1.15
        this.swiper.params.loop = true
      } else {
        this.swiper.params.slidesPerView = 1
        this.swiper.params.loop = false
      }
    }

    this.swiper.allowTouchMove = mediaItems.length <= 1 ? false : true

    this.swiper.update()

    // Swipe to the first slide without animation.
    this.swiper.slideToLoop(0, 0)

    this.renderThumbnails(thumbnailItems)
  }
}

Stimulus.register("product-card-images", ProductCardImagesController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(695)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);